/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface GetUserControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 사용자 역할
 */
  role?: 'PARENT' | 'TEACHER' | 'ALL';

/**
 * 보호자 ID
 */
  guardianId?: string;

/**
 * 소속 센터
 */
  centerIds?: Array<string>;

/**
 * 상태
 */
  status?: Array<'ACTIVE' | 'WITHDRAWN' | 'BLOCKED'>;

/**
 * 생년월일
 */
  birthStartAt?: string;

/**
 * 생년월일
 */
  birthEndAt?: string;

/**
 * 가입일
 */
  startAt?: string;

/**
 * 가입일
 */
  endAt?: string;
}

export function getUserControllerSearchOffset(http: HttpClient, rootUrl: string, params: GetUserControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, getUserControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('role', params.role, {});
    rb.query('guardianId', params.guardianId, {});
    rb.query('centerIds', params.centerIds, {});
    rb.query('status', params.status, {});
    rb.query('birthStartAt', params.birthStartAt, {});
    rb.query('birthEndAt', params.birthEndAt, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

getUserControllerSearchOffset.PATH = '/api/user/search/offset';
